<script>
/**
 * Descripción: Pantalla de error NetworkIssue
 *
 * @displayName NetworkIssueViewComponent
 */

const TheError = () => import('@/components/core/layouts/TheError.vue');

export default {
  name: 'NetworkIssueViewComponent',

  components: {
    TheError
  }
};
</script>

<template>
  <TheError>
    <div slot="Img">
      <v-img src="@/assets/500.svg" max-height="580" max-width="580" />
    </div>

    <div slot="RenderBody">
      <h1 class="display-2" style="color:#2c3e50;">¡Ups!, 500</h1>
      <br />
      <v-btn to="/" color="#2c3e50" outlined>¡Sácame de aquí!</v-btn>
    </div>
  </TheError>
</template>
